import { useStaff } from "@gymflow/api";
import { useContext, useEffect, useState } from "react";

import { Spinner } from "../components/atoms";
import { usePortalRoutes } from "../hooks/usePortalRoutes";
import { useClubSettings } from "../providers";
import { AuthenticationContext } from "../providers/authentication/AuthenticationContext";
import useGymflowModels from "../store";

export function Roadmap() {
  const { api } = useGymflowModels();
  const { userId: id } = useContext(AuthenticationContext);
  const { data: staff } = useStaff({ api, staffId: id });
  const { club } = useClubSettings();
  const { routeId, brand, company } = usePortalRoutes();

  const [isSdkLoaded, setIsSdkLoaded] = useState(false);

  useEffect(() => {
    if (!club || !staff) {
      return;
    }
    const details = {
      organization: "gymflow",

      email: staff.email,
      name: `${staff.firstName} ${staff.lastName}`,
      id: staff.id,

      customFields: {
        brand,
        company,
        routeId,
      },

      companies: [
        {
          id: club.id.toString(),
          name: club.name,
        },
      ],
    } as any;
    if (staff.picture && staff.picture.startsWith("http")) {
      details.profilePicture = staff.picture;
    }

    window.Featurebase(
      "init_embed_widget",
      {
        organization: "gymflow",
        embedOptions: {
          path: "/",
          filters: "",
        },
        stylingOptions: {
          theme: "light",
          hideMenu: false,
          hideLogo: false,
        },
      },
      (err: any, callback: any) => {
        if (callback?.action === "widgetReady") {
          setIsSdkLoaded(true);
        }
      },
    );
  }, [brand, club, company, routeId, staff]);
  return (
    <div className="relative flex size-full">
      <div data-featurebase-embed className="flex size-full"></div>
      {!isSdkLoaded && (
        <div className="absolute inset-0 flex size-full items-center justify-center">
          <Spinner />
        </div>
      )}
    </div>
  );
}
